<!-- Card -->
<div class="d-block border-bottom pb-5 mb-5">
  <div class="row mx-md-n2">
    <div class="col-md-4 px-md-2 mb-3 mb-md-0">
      <div class="position-relative">
        <a routerLink="/helpful-information/reviews">
          <img class="img-fluid w-100 rounded-lg" [appLazyload]=imagePath alt="Machame Route 6 Day Trip">

          <div *ngIf="shoutout && shoutout.length > 0" class="position-absolute top-0 left-0 mt-3 ml-3">
            <small class="btn btn-xs btn-success btn-pill text-uppercase shadow-soft py-1 px-2 mb-3">{{shoutout}}</small>
          </div>

          <div class="position-absolute bottom-0 left-0 mb-3 px-4 py-1 stars-custom">
            <div class="d-flex align-items-center flex-wrap">
              <ul class="list-inline mt-n1 mb-0 mr-2">
                <li class="list-inline-item mx-0"><img src="../assets/svg/icons/star.svg" alt="Review rating" width="14"></li>
                <li class="list-inline-item mx-0"><img src="../assets/svg/icons/star.svg" alt="Review rating" width="14"></li>
                <li class="list-inline-item mx-0"><img src="../assets/svg/icons/star.svg" alt="Review rating" width="14"></li>
                <li class="list-inline-item mx-0"><img src="../assets/svg/icons/star.svg" alt="Review rating" width="14"></li>
                <li class="list-inline-item mx-0"><img src="../assets/svg/icons/star.svg" alt="Review rating" width="14"></li>
              </ul>
              <span class="d-inline-block">
                <small class="font-weight-bold text-white mr-1">{{reviewRating}}</small>
                <small class="text-white-70">(18+ reviews)</small>
              </span>
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="col-md-8">
      <div class="media mb-2">
        <a routerLink="{{learnMoreUrl}}">
          <div>
            <div class="d-flex mt-1 ml-7 float-right">
              <div class="text-right">
                <small class="d-block text-muted text-lh-sm"><del>{{strikedPrice}}</del></small>
                <span class="d-block h4 text-fg text-lh-sm mb-0">{{price}}</span>
              </div>
            </div>
            <div class="media-body">
              <h3 class="text-hover-primary ">{{title}}</h3>
            </div>
          </div>
        </a>
      </div>

      <div class="d-flex flex-wrap flex-xl-nowrap justify-content-start align-items-center small text-muted mb-2">
        <div class="d-flex align-items-center">
          <div class="avatar-group">
            <span data-toggle="tooltip" data-placement="top" title="Reschedule your trip, fee free! We are here for you.">
              <img appLazyload="icons/top-choice.svg" width="14" alt="Flexible Booking Guarantee">
              <span class="ml-2">Flexible Booking Guarantee</span>
            </span>
          </div>
        </div>
        <div class="ml-lg-auto mt-2 mt-lg-0 d-flex flex-nowrap">
          <div>
            <app-fa-icon [iconName]="tourIcon" classes="mr-1" bottomMargin="-0.2rem" color="muted"></app-fa-icon>
            Private tour
          </div>
          <span class="text-muted mx-2">|</span>
          <div class="d-inline-block">
            <app-fa-icon iconName="clock" classes="mr-1" bottomMargin="-0.2rem" color="muted"></app-fa-icon>
            {{durationSnippet}}
          </div>
          <span class="text-muted mx-2">|</span>
          <div class="d-inline-block">
            <app-fa-icon iconName="signal" classes="mr-1" bottomMargin="-0.2rem" color="muted"></app-fa-icon>
            {{skillRating}}
          </div>
        </div>
      </div>

      <p class="font-size-1 text-fg mb-0">{{description}}</p>
      <div class="d-flex flex-wrap mt-2">
        <a role="button" style="cursor: pointer!important;" href="https://fareharbor.com/embeds/book/kopatours/items/{{calendarId}}/?flow=237165&back={{refUrl}}"
           class="btn btn-pill py-n2 text-fg btn-primary px-6 ml-auto">FIND A DATE NOW<app-fa-icon iconName="calendar" classes="ml-2" bottomMargin="-0.2rem"></app-fa-icon></a>
        <span style="flex-basis:100%; width: 0"></span>
        <small class="text-muted ml-auto mr-5 mt-1">DEPARTURES EVERY DAY</small>
      </div>
    </div>
  </div>
</div>
<!-- End Card -->
